export default __webpack_public_path__ + "static/media/pic10.c1fd268f.png";